import { PROMO_CODE, PROVIDER_NAME } from "../config";
import { PlanProps } from "../types";

export const CNP_CODES = [
  "OFFERHL1",
  "OFFERHL3",
  "OFFERHL6",
  "OFFERHM1",
  "OFFERHP3",
  "OFFERHR1"
];
export const ONCOR_CODES = [
  "OFFERHL2",
  "OFFERHL4",
  "OFFERHL7",
  "OFFERHM2",
  "OFFERHP4",
  "OFFERHR2",
];
export const DM_CODES =[
  'OFFERKA1',
  'OFFERKA4'
]
export const LPL_CODES = ["OFFERHP7", "OFFERHP8"];

export const KH_CODES_MAP: { [key: string]: { zipcode: string } } = {
  "OFFERKH1": {
    "zipcode": "77479", // two provider kh
  },
  "OFFERKH2": {
    "zipcode": "77479",
  },
  "OFFERKH3": {
    "zipcode": "75201", // two provider kh
  },
  "OFFERKH4": {
    "zipcode": "75201",
  },
  // "OFFERKH1": {
  //   "zipcode": "75201",
  // },
  // "OFFERKH2": {
  //   "zipcode": "75201",
  // },
  // "OFFERKH3": {
  //   "zipcode": "77479",
  // },
  // "OFFERKH4": {
  //   "zipcode": "77479",
  // },
}

// export const KH_CODES = ["OFFERHR2", "OFFERHP4" , "OFFERHM2", "OFFERHL7",];
export const KH_CODES = Object.keys(KH_CODES_MAP);
export const AC_OFFER_CODES = [...CNP_CODES, ...ONCOR_CODES, ...LPL_CODES, ...KH_CODES];

export const getPlanName = (val: PlanProps, promo_code?: string) => {
  if (!val) {
    return;
  }
  let planName = getPlanNameHelper(promo_code);
  let name =
    planName.filter((item) => item.id === Number(val.plan_id))[0] ||
    planName.filter((item) => item.key.indexOf(val.plan_name) > -1)[0];
  if (name) {
    return name.value;
  } else {
    return val.plan_name;
  }
};

export const getPlanNameHelper = (promo_code: string = PROMO_CODE) => {
  const eiqPPCPlans = [
    {
      id: 307,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 322,
      key: "12Mo Usage Bill Credit + A/C Protection for 2 Units and HVAC Monitoring",
      value: "AC Protect 12",
    },
    {
      id: 5081,
      key: "15 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 15",
    },
    {
      id: 11292,
      key: "18 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 18",
    },
    {
      id: 493,
      key: "24Mo Usage Bill Credit + A/C Protection for 2 Units and HVAC Monitoring",
      value: "AC Protect 24",
    },
    {
      id: 481,
      key: "24 Month Usage Bill Credit",
      value: "Usage Bill Credit 24",
    },
    {
      id: 492,
      key: "24Mo Usage Bill Credit + A/C Protection for 1 Unit and HVAC Monitoring",
      value: "AC Protect 24",
    },
    {
      id: 9551,
      key: "24 Month A/C Protect Premier for 2 Units",
      value: "AC Protect Premier 24",
    },
    {
      id: 304,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 7667,
      key: "15 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 15",
    },
    {
      id: 11294,
      key: "18 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 18",
    },
    {
      id: 482,
      key: "24 Month Usage Bill Credit",
      value: "Usage Bill Credit 24",
    },
    {
      id: 308,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 3302,
      key: "15 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 15",
    },
    {
      id: 483,
      key: "24 Month Usage Bill Credit",
      value: "Usage Bill Credit 24",
    },
    {
      id: 305,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 5881,
      key: "15 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 15",
    },
    {
      id: 11296,
      key: "18 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 18",
    },
    {
      id: 484,
      key: "24 Month Usage Bill Credit",
      value: "Usage Bill Credit 24",
    },
    {
      id: 306,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 9411,
      key: "15 Month Usage Bill Credit + PowerPlug",
      value: "Usage Bill Credit 15",
    },
    {
      id: 11295,
      key: "18 Month Usage Bill Credit + PowerPlug ",
      value: "Usage Bill Credit 18",
    },
    {
      id: 485,
      key: "24 Month Usage Bill Credit",
      value: "Usage Bill Credit 24",
    },
  ];
  if (promo_code === "ROCKSTAR" || promo_code === "EIQPPC") {
    return eiqPPCPlans;
  } else if (AC_OFFER_CODES.includes(promo_code)) {
    return [
      {
        id: 5131,
        key: "12 Month Usage Bill Credit",
        value: "12 Month Usage Bill Credit",
        gcIncentive: "$75",
      },
      {
        id: 5132,
        key: "12 Month Usage Bill Credit",
        value: "12 Month Usage Bill Credit",
        gcIncentive: "$75",
      },
      {
        id: 12109,
        key: "12 Month A/C Protect Plus for 2 Units",
        value: "12 Month A/ C Protect Plus",
        gcIncentive: "$75",
      },
      {
        id: 12108,
        key: "12 Month A/C Protect Plus for 2 Units",
        value: "12 Month A/ C Protect Plus",
        gcIncentive: "$75",
      },
      {
        id: 10718,
        key: "36 Month A/C Protect Plus for 2 Units + $75 Gift Card",
        value: "36 Month A/C Protect Plus",
      },
      {
        id: 10724,
        key: "36 Month A/C Protect Plus for 2 Units + $75 Gift Card",
        value: "36 Month A/C Protect Plus",
      },
      // OFFERHP3 and OFFERHP4
      {
        id: 13109,
        key: "12 Month Usage Bill Credit",
        value: "12 Month Usage Bill Credit",
        gcIncentive: "$75",
      },
      {
        id: 13113,
        key: "12 Month Usage Bill Credit",
        value: "12 Month Usage Bill Credit",
        gcIncentive: "$75",
      },
      {
        id: 13110,
        key: "36 Month Usage Bill Credit",
        value: "36 Month Usage Bill Credit",
        gcIncentive: "$75",
      },
      {
        id: 13112,
        key: "36 Month Usage Bill Credit",
        value: "36 Month Usage Bill Credit",
        gcIncentive: "$75",
      },
      {
        id: 13111,
        key: "12 Month A/C Protect Plus for 2 Units",
        value: "12 Month A/ C Protect Plus",
        gcIncentive: "$75",
      },
      {
        id: 13114,
        key: "12 Month A/C Protect Plus for 2 Units",
        value: "12 Month A/ C Protect Plus",
        gcIncentive: "$75",
      },
      // OFFERHR1 and OFFEERHR2
      {
        id: 13254,
        key: "12 Month A/C Protect Plus for 2 Units",
        value: "12 Month A/ C Protect Plus",
        gcIncentive: "$75",
      },
      {
        id: 13257,
        key: "12 Month A/C Protect Plus for 2 Units",
        value: "12 Month A/ C Protect Plus",
        gcIncentive: "$75",
      },
    ];
  }
  return [
    {
      id: 780,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 304,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 305,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 306,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 5798,
      key: "12 Month Usage Bill Credit",
      value: "Usage Bill Credit 12",
    },
    {
      id: 322,
      key: "12Mo Usage Bill Credit + A/C Protection for 2 Units and HVAC Monitoring",
      value: "AC Protect 12",
    },
    {
      id: 323,
      key: "12Mo Usage Bill Credit + A/C Protection for 2 Units and HVAC Monitoring",
      value: "AC Protect 12",
    },
    {
      id: 736,
      key: "12 Month A/C Protect Plus for 2 Units",
      value: "AC Protect Plus 12",
    },
    {
      id: 737,
      key: "12 Month A/C Protect Plus for 2 Units",
      value: "AC Protect Plus 12",
    },
    {
      id: 10441,
      key: "12 Month A/C Protect Premier for 2 Units",
      value: "AC Protect Premier 12",
    },
    {
      id: 10442,
      key: "12 Month A/C Protect Premier for 2 Units",
      value: "AC Protect Premier 12",
    },
    {
      id: 627,
      key: "36 Month Usage Bill Credit",
      value: "Usage Bill Credit 36",
    },
    {
      id: 628,
      key: "36 Month Usage Bill Credit",
      value: "Usage Bill Credit 36",
    },
    {
      id: 629,
      key: "36 Month Usage Bill Credit",
      value: "Usage Bill Credit 36",
    },
    {
      id: 630,
      key: "36 Month Usage Bill Credit",
      value: "Usage Bill Credit 36",
    },
    {
      id: 631,
      key: "36 Month Usage Bill Credit",
      value: "Usage Bill Credit 36",
    },
    {
      id: 636,
      key: "36Mo Usage Bill Credit + A/C Protection for 2 Units and HVAC Monitoring",
      value: "AC Protect 36",
    },
    {
      id: 6853,
      key: "36Mo Usage Bill Credit + A/C Protection for 2 Units and HVAC Monitoring",
      value: "AC Protect 36",
    },
    {
      id: 10714,
      key: "36 Month A/C Protect Plus for 2 Units",
      value: "AC Protect Plus 36",
    },
    {
      id: 10720,
      key: "36 Month A/C Protect Plus for 2 Units",
      value: "AC Protect Plus 36",
    },
    {
      id: 10716,
      key: "36 Month A/C Protect Premier for 2 Units",
      value: "AC Protect Premier 36",
    },
    {
      id: 10722,
      key: "36 Month A/C Protect Premier for 2 Units",
      value: "AC Protect Premier 36",
    },
    {
      id: 6068,
      key: "6 Month Usage Bill Credit",
      value: "Usage Bill Credit 6",
    },
  ];
};
export const getBestRate = (promo_code: string = PROMO_CODE) => {
  if (promo_code === "ROCKSTAR" || promo_code === "EIQPPC") {
    return [
      627, 780, 306, 631, 304, 628, 5798, 629, 307, 5081, 11292, 304, 7667,
      11294, 308, 3302, 305, 5881, 11296, 9411, 11295,
    ];
  }
  // Ac Protection Grid
  else if (AC_OFFER_CODES.includes(promo_code)) {
    return [10718, 12109, 12108, 10724, 13114, 13111, 13254, 13257];
  }
  return [322, 493, 481, 492, 9551, 482, 483, 484, 485];
};
export const getBestValue = (promo_code: string = PROMO_CODE) => {
  if (promo_code === "ROCKSTAR" || promo_code === "EIQPPC") {
    return [
      322, 636, 736, 10441, 10714, 10716, 323, 737, 10442, 6853, 10720, 10722,
      493, 481, 492, 9551, 482, 484, 485, 6068, 483,
    ];
  }
  // Ac Protection Grid
  else if (AC_OFFER_CODES.includes(promo_code)) {
    return [5131, 5132, 13113, 13112, 13109, 13110, 13252, 13253, 13256, 13255];
  }
  return [322, 493, 481, 492, 9551, 482, 483, 484, 485];
};

// export const BestRate = PROMO_CODE !== 'EIQPPC' ?
//     [307, 5081, 11292, 304, 7667, 11294, 308, 3302, 305, 5881, 11296, 306, 9411, 11295] :
//     [627, 780, 306, 631, 304, 628, 5798, 629, 307, 5081, 11292, 304, 7667, 11294, 308, 3302, 305, 5881, 11296, 9411, 11295]
// export const BestValue = PROMO_CODE !== 'EIQPPC' ?
//     [322, 493, 481, 492, 9551, 482, 483, 484, 485] :
//     [322, 636, 736, 10441, 10714, 10716, 323, 737, 10442, 6853, 10720, 10722, 493, 481, 492, 9551, 482, 484, 485, 6068, 483]

export const PhoneNumbers: {
  [key: string]: any;
} = {
  OFFERHL1: "855-847-7893",
  OFFERHL2: "855-388-9367",
  OFFERHL3: "855-907-4229",
  OFFERHL4: "855-919-1345",
  OFFERHL6: "877-881-5205",
  OFFERHL7: "877-881-1647",
  OFFERHM1: "877-873-1887",
  OFFERHM2: "877-873-6771",
  EIQPPC: "877-352-3194",
  ROCKSTAR: "877-352-3194",
  OFFERHP5: "877-377-4869",
  OFFERHP6: "877-737-6356",
  OFFERHR1: "877-881-5205",
  OFFERHR2: "877-881-1647",
  OFFERHP8: "855-944-4051",
  OFFERKA4: "877-881-1647",
  OFFERKA1: "877-881-5205",
  OFFERKH1: "888-832-1048",
  OFFERKH2: "888-832-3695",
  OFFERKH3: "888-873-9785",
  OFFERKH4: "888-832-2239"

};

export const pushToDataLayer = (eventData: any) => {
  if (window.dataLayer) {
    window.dataLayer.push(eventData);
  } else {
    console.warn("dataLayer is not defined");
  }
};